import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import actionConstants from '../../services/scheduler/constants';
import classNames from 'classname';

const DayCell = ({ value, checkIsEmpty, buyerSchedules, setActiveDate }) => {
    const dispatch = useDispatch();
    const scheduler = useSelector(state => state.scheduler);
    const activeDay = useSelector(state => state.scheduler.activeDateSlot);

    const handleClick = () => {
        if (buyerSchedules) {
            dispatch({ type: actionConstants.SET_ACTIVE_DAY_SLOT, data: value });
            setActiveDate(value);
        }
        else {
            var IsSelectedSlots = checkIsEmpty(activeDay, true);
            if (IsSelectedSlots) {
                dispatch({ type: actionConstants.SET_ACTIVE_DAY_SLOT, data: value })
                setActiveDate(value);
            }
        }
    }
    const isActive = value === scheduler.activeDateSlot;
    const className = classNames({
        'day-cell': true,
        'day-cell--active': isActive
    });

    const selectedTimeSlotsAmount = (scheduler.schedule[value] || []).length;
    const selectedDays = Object.keys(scheduler.schedule) || [];
    const selectedDay = selectedDays[0];

    const selectedDaysAmount = selectedDays.length;

    useEffect(() => {
        if (selectedDaysAmount === 1) {
            dispatch({ type: actionConstants.SET_ACTIVE_DAY_SLOT, data: selectedDay });
        }
    }, [selectedDaysAmount, dispatch, selectedDay]);

    return (
        <div className={className} onClick={handleClick}>
            {selectedTimeSlotsAmount > 0 && (
                <span className='day-cell__available-slots-label'>
                    {selectedTimeSlotsAmount}
                </span>
            )}
            {value}
        </div>
    );
}

export default DayCell;